"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminDemandPartnersComponent = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//INTERNAL BITS
const admin_service_1 = require("./admin.service");
const clients_service_1 = require("./clients.service");
const permission_service_1 = require("./permission.service");
const notification_service_1 = require("./notification.service");
const slug_pipe_1 = require("./slug.pipe");
const version_service_1 = require("./version.service");
const demand_partner_type_service_1 = require("./demand-partner-type.service");
const demand_partner_service_1 = require("./demand-partner.service");
const demand_partner_1 = require("./demand-partner");
const demand_partner_2 = require("./demand-partner");
const demand_partner_3 = require("./demand-partner");
let AdminDemandPartnersComponent = class AdminDemandPartnersComponent {
    constructor(_talk, _admin, _cd, _slug, _clients, _version, _permission, _demandPartnerTypes, _demandPartner) {
        this._talk = _talk;
        this._admin = _admin;
        this._cd = _cd;
        this._slug = _slug;
        this._clients = _clients;
        this._version = _version;
        this._permission = _permission;
        this._demandPartnerTypes = _demandPartnerTypes;
        this._demandPartner = _demandPartner;
        this.demandPartner = new demand_partner_1.DemandPartner;
        this.param = new demand_partner_2.DemandPartnerParam;
        this.paramTypes = [
            "string",
            'numeric',
            "object",
            "array",
            "boolean"
        ];
        this.demandPartner.type = new demand_partner_3.DemandPartnerType;
    }
    ngOnInit() {
        this.permissions = this._permission.get();
        this.clients = this._clients.get();
        this.demandPartners = this._demandPartner.get();
        this.demandPartner.minVersion = this._version.getBiddrPlusVersion();
        this.demandPartner.params = [];
        Promise.resolve(this.adEngineVersions = this._version.getAllBiddrPlusVersions()).then(err => {
            this._cd.markForCheck();
        });
        Promise.resolve(this.demandPartnerTypes = this._demandPartnerTypes.get()).then(err => {
            this.demandPartner.type = this.demandPartnerTypes[0];
            this._cd.markForCheck();
        });
    }
    addParam(param) {
        this.demandPartner.params.push(param);
        this.param = new demand_partner_2.DemandPartnerParam;
    }
    createDemandPartner(dp) {
        if (!dp.slug) {
            dp.slug = this._slug.transform(dp.name);
        }
        dp.code = dp.slug;
        dp.type = dp.type.id;
        if (this.demandPartners.filter(r => { return r.code == dp.slug; }).length > 0) {
            return this._talk.broadcast("A demand partner by this name already exists.");
        }
        Promise.resolve(this._admin.createDemandPartner(dp))
            .then(err => {
            this.demandPartner = new demand_partner_1.DemandPartner;
            this.demandPartner.minVersion = this._version.getBiddrPlusVersion();
            this.demandPartner.params = [];
            this.demandPartner.type = this.demandPartnerTypes[0];
            Promise.resolve(this._clients.pull()).then(err => {
                this.clients = this._clients.get();
                this._cd.markForCheck();
            }).catch(err);
        }).catch(err => {
            if (err.status == 400) {
                this._talk.broadcast("There was an issue creating your new demand partner: " + JSON.parse(err._body).invalidAttributes.code[0].message);
            }
            else if (err) {
                this._talk.broadcast("There was an issue creating your new demand partner.  Please contact your administrator.");
            }
        });
    }
    removeParam(index) {
        this.demandPartner.params.splice(index, 1);
    }
};
exports.AdminDemandPartnersComponent = AdminDemandPartnersComponent;
exports.AdminDemandPartnersComponent = AdminDemandPartnersComponent = __decorate([
    (0, core_1.Component)({
        selector: 'admin-demand-partners',
        templateUrl: 'app/admin-demand-partners.component.html',
        styleUrls: ['styles/admin.component.css'],
    }),
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [notification_service_1.NotificationService,
        admin_service_1.AdminService,
        core_1.ChangeDetectorRef,
        slug_pipe_1.SlugPipe,
        clients_service_1.ClientsService,
        version_service_1.VersionService,
        permission_service_1.PermissionService,
        demand_partner_type_service_1.DemandPartnerTypeService,
        demand_partner_service_1.DemandPartnerService])
], AdminDemandPartnersComponent);
//# sourceMappingURL=admin-demand-partners.component.js.map